import {Pageable} from './pageable.model';

export class Page<T> {
    content: T[] = [];
    totalElements: number;
    totalPages: number;
    last: boolean;
    first: boolean;
    numberOfElements: number;
    number: number;
    size: number;
    pageable: Pageable;

    public static empty<T>(): Page<T> {
        const page: Page<T> = new Page();
        page.totalElements = 0;
        page.content = [];
        page.totalPages = 0;
        page.last = true;
        page.first = true;
        page.numberOfElements = 0;
        page.number = 0;
        page.size = 0;
        page.pageable = Pageable.of(0, 0);
        return page;
    }

    public static clone<T>(pageToClone: Page<any>, content: T[]): Page<T> {
        const page: Page<T> = this.empty();
        page.totalElements = pageToClone.totalElements;
        page.content = [];
        page.totalPages = pageToClone.totalPages;
        page.last = pageToClone.last;
        page.first = pageToClone.first;
        page.numberOfElements = pageToClone.numberOfElements;
        page.number = pageToClone.number;
        page.size = pageToClone.size;
        page.pageable = pageToClone.pageable;
        page.content = content;
        return page;
    }
}
